"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsView = void 0;
const React = require("react");
const react_1 = require("react");
const SalesOrderContext_1 = require("../../contexts/SalesOrderContext");
const ProductsContext_1 = require("../../contexts/ProductsContext");
const AppScreen_1 = require("../../../../../components/base/atoms/AppScreen");
const getUniqSortedCategories_1 = require("../../helpers/getUniqSortedCategories");
const PendingContentBlock_1 = require("../../../../../components/base/structure/PendingContentBlock");
const Loader_1 = require("../../../../../components/base/atoms/Loader");
const CartSidePanel_1 = require("../../atoms/CartSidePanel");
const ShowCartButton_1 = require("../../atoms/ShowCartButton");
const ProductsViewHeader_1 = require("./ProductsViewHeader");
const ProductsMenu_1 = require("./ProductsMenu");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ProductsView");
const ProductsView = ({}) => {
    const [showCart, setShowCart] = (0, react_1.useState)(false);
    const { products } = (0, react_1.useContext)(ProductsContext_1.ProductsContext);
    const { isUpdatingCart } = (0, react_1.useContext)(SalesOrderContext_1.SalesOrderContext);
    const categories = (0, react_1.useMemo)(() => {
        if (products === null) {
            return null;
        }
        return (0, getUniqSortedCategories_1.getUniqSortedCategories)(products);
    }, [products]);
    return (React.createElement(Loader_1.LoadingOverlay, { className: css("loader"), text: "updating cart...", visible: isUpdatingCart },
        React.createElement(AppScreen_1.AppScreen, null,
            React.createElement(ProductsViewHeader_1.ProductsViewHeader, { categories: categories }),
            React.createElement(AppScreen_1.AppScreenBody, null,
                categories === null || products === null ? (React.createElement(PendingContentBlock_1.PendingContentBlock, { check: false, message: "Loading product list...", size: "full" })) : (React.createElement("div", { className: css("") },
                    React.createElement(ProductsMenu_1.ProductsMenu, { categories: categories }))),
                React.createElement(CartSidePanel_1.CartSidePanel, { open: showCart, setOpen: setShowCart })),
            React.createElement(AppScreen_1.AppScreenFooter, null,
                React.createElement(ShowCartButton_1.ShowCartButton, { setShowCart: setShowCart })))));
};
exports.ProductsView = ProductsView;
//# sourceMappingURL=index.js.map